export const CAROUSEL_PROPS = {
    dots: false,
    centerMode: false,
    infinite: true,
    slidesToScroll: 2,
    draggable: false,
    easing: "ease-in-out",
    arrows: true,
    focusOnSelect: false,
    showFocusEffect: false
};
